// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VxUYS13KASBCYZ {
  visibility: hidden;
}
.dUDdZV1IG0wcwi {
  max-width: 200px;
  height: 115px;
  background-color: var(--ds-background-neutral, #091e420f);
  vertical-align: middle;
}
.dUDdZV1IG0wcwi .mbg4GRcTODbQp1 {
  width: 150px;
  margin-right: auto;
  margin-left: auto;
}
.dUDdZV1IG0wcwi .oRoYhRTpVFIO9l {
  color: var(--ds-text-subtle, #44546f);
}
.dUDdZV1IG0wcwi .EV90QvcJdigZFv {
  margin-top: 24px;
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  letter-spacing: -0.006em;
  line-height: 20px;
  font-weight: 600;
}
.TTmWMGK7lDePf_ {
  text-align: center;
}
.hSf7cMnqtrtOux {
  margin-top: 24px;
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  letter-spacing: -0.006em;
  line-height: 20px;
  font-weight: 600;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noCell": `VxUYS13KASBCYZ`,
	"cell": `dUDdZV1IG0wcwi`,
	"text": `mbg4GRcTODbQp1`,
	"total": `oRoYhRTpVFIO9l`,
	"price": `EV90QvcJdigZFv`,
	"contactBtn": `TTmWMGK7lDePf_`,
	"cellHeader": `hSf7cMnqtrtOux`
};
export default ___CSS_LOADER_EXPORT___;
